import { Box, IconButton, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import Profile from './Profile';
import MobileSection from './MobileSection';
import Tooltip from '@mui/material/Tooltip';
import Search from './Search';
import { HeaderContentRight } from '../AppBarStyled';
import Typography from '@mui/material/Typography';


const HeaderContent = () => {
  const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const STOP_REGION = process.env.REACT_APP_STOP_REGION

  return (
    <>
      {!matchesXs && (
        <Grid container>
          <Grid item xs={12} sm={6}>
            {
            // <Search />
              <Typography pt={1} variant='h3'>WestCare STOP Region {STOP_REGION === '3' ? 'III' : 'I'}</Typography>
            }
          </Grid>
          <HeaderContentRight item xs={12} sm={6}>
            <Link to='/' style={{ textDecoration: 'none', color: '#000000' }}>
              <IconButton
                disableRipple
                color='secondary'
                sx={{ color: 'text.primary', bgcolor: 'grey.100' }}
              >
                <Tooltip title='Dashboard'>
                  <HomeIcon />
                </Tooltip>
              </IconButton>
            </Link>
            <Profile />
          </HeaderContentRight>
        </Grid>
      )}
      {matchesXs && 
          <Box sx={{ width: '100%', ml: 1 }}>
            <Typography pt={1} variant='h3'>WestCare STOP Region {STOP_REGION === '3' ? 'III' : 'I'}</Typography>
          </Box>
      }
      {matchesXs && <MobileSection />}
    </>
  );
};

export default HeaderContent;
